import { InlineImageWithOwnerModel } from './inline-image-with-owner.model';
import { RedactAttachmentsResponseModel } from './redact-attachments-response.model';

export class TicketRedactionModel {
    text: string;
    inlineImages: InlineImageWithOwnerModel[];
    attachmentsIds: number[];

    public constructor(text: string, attachmentsData: RedactAttachmentsResponseModel) {
        this.text = text;
        this.inlineImages = attachmentsData.inlineImages
            .filter((image) => image.isMarked)
            .map((image) => {
                delete image.isMarked;
                return image;
            });

        this.attachmentsIds = attachmentsData.attachments.filter((image) => image.isMarked).map((image) => image.id);
    }
}
